module.exports = __webpack_public_path__ + "img/cover.f2b23e17.png";